// extracted by mini-css-extract-plugin
module.exports = {"singleColPage":"SingleColPage_singleColPage__1jcfd","wrapperDiv":"SingleColPage_wrapperDiv__xuw1A","region":"SingleColPage_region__WKyAZ"};